import { DataModelBuilder, isSameData, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { PoolBookingSettings } from '../../models/serializable/pool-booking-settings.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class PoolBookingSettingsComponent extends Component {
  static readonly TYPE_ID: string = '155d1d0f512d4dc1b90fa7b2c52f9d6a';

  constructor(
        public readonly settings: PoolBookingSettings,
  ) {
    super();
  }

  get $typeId(): string {
    return PoolBookingSettingsComponent.TYPE_ID;
  }

  get $removable(): boolean {
    return false;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PoolBookingSettingsComponent {
    return new PoolBookingSettingsComponent(
        context.fromData<PoolBookingSettings>(MapUtils.getRaw(map, 'settings') as SerializedData),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'settings': context.toData(this.settings),
    };
  }

  clone(): this {
    return new PoolBookingSettingsComponent(
        this.settings.clone(),
    ) as this;
  }

  isSame(other: PoolBookingSettingsComponent): boolean {
    if(this === other) {
      return true;
    }

    return isSameData(other.settings, this.settings);
  }
}

export class PoolBookingSettingsComponentBuilder extends DataModelBuilder<PoolBookingSettingsComponent> {
  build(context: SerializationContext, map: SerializedData): PoolBookingSettingsComponent {
    return PoolBookingSettingsComponent.fromMap(context, map);
  }
}
